module.exports = __webpack_public_path__ + "static/media/imgop_caseStudies.785ade58.webp";